const httpResponse = {
  success: true,
  data: null,
  message: null,
  isConnected: true
};
export default httpResponse;



// WEBPACK FOOTER //
// ./src/services/HttpResponse/index.js